import { Loader2, Gamepad2, Sparkles } from 'lucide-react';

interface LoadingOverlayProps {
    text?: string;
}

export default function LoadingOverlay({ text = 'Loading...' }: LoadingOverlayProps) {
    return (
        <div style={{
            position: 'fixed',
            inset: 0,
            background: 'rgba(5, 8, 16, 0.90)',
            backdropFilter: 'blur(12px)',
            WebkitBackdropFilter: 'blur(12px)',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            zIndex: 9999,
        }}>
            <div className="animate-in" style={{
                position: 'relative',
                background: 'rgba(12, 18, 36, 0.95)',
                border: '1px solid rgba(99, 102, 241, 0.3)',
                borderRadius: 'var(--radius-lg)',
                padding: '40px 60px',
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                justifyContent: 'center',
                boxShadow: '0 0 40px rgba(99, 102, 241, 0.15), inset 0 1px 1px rgba(255, 255, 255, 0.05)',
                textAlign: 'center',
                minWidth: '320px',
                overflow: 'hidden',
            }}>
                {/* Decorative glowing orb behind content */}
                <div style={{
                    position: 'absolute',
                    top: '50%',
                    left: '50%',
                    transform: 'translate(-50%, -50%)',
                    width: 150,
                    height: 150,
                    background: 'radial-gradient(circle, rgba(99,102,241,0.2) 0%, transparent 70%)',
                    pointerEvents: 'none',
                    zIndex: 0
                }} />

                <div style={{ position: 'relative', zIndex: 1, display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                    <div style={{ position: 'relative', marginBottom: 24, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                        <Loader2 size={64} className="spin" style={{ color: 'rgba(99, 102, 241, 0.5)' }} />
                        <Gamepad2 size={28} style={{ color: 'var(--accent)', position: 'absolute' }} className="pulse" />
                        <Sparkles size={16} style={{ color: 'var(--neon-pink)', position: 'absolute', top: -10, right: -10, opacity: 0.8 }} className="pulse" />
                    </div>
                    <h3 style={{ 
                        fontFamily: 'Outfit', 
                        fontWeight: 700, 
                        fontSize: '1.3rem', 
                        margin: 0, 
                        background: 'var(--accent-gradient)',
                        WebkitBackgroundClip: 'text',
                        WebkitTextFillColor: 'transparent',
                        backgroundClip: 'text',
                        letterSpacing: '0.5px' 
                    }}>
                        {text}
                    </h3>
                </div>
            </div>
        </div>
    );
}
